<template>
    <div
        class="cinema-seat-page page"
        :class="{ 'show-seat-info': renderData.areaPrices && renderData.areaPrices.length }"
    >
        <div class="price-box" ref="priceBox">
            <div class="seat-info">
                <div class="line">
                    <div class="item">
                        <img class="img" src="@/assets/icons/select-default.png" />
                        <div class="value">已售</div>
                    </div>
                    <div class="item">
                        <img class="img" src="@/assets/icons/my-select-default.png" />
                        <div class="value">已选</div>
                    </div>
                    <div class="item">
                        <img class="img" src="@/assets/icons/default-0-default.png" />
                        <div class="value">可选</div>
                    </div>
                </div>
                <div class="line" v-if="renderData.areaPrices">
                    <div class="item" v-for="(item, index) in renderData.areaPrices" :key="index">
                        <img
                            class="img"
                            :src="
                                require('@/assets/icons/default-' +
                                    (index < 2 ? index : 2) +
                                    '-default.png')
                            "
                        />
                        <div class="value">{{ item.price }}</div>
                    </div>
                </div>
                <Thumbnail
                    class="thumbnail"
                    :middleColumn="renderData.middleColumn"
                    :seatList.sync="seatList"
                    v-if="thumbnailRefresh && seatList.length > 0"
                ></Thumbnail>
            </div>
            <div class="selection-name">{{ renderData.hallName }}</div>
        </div>
        <div class="h5-cinema-box" :style="{ top: priceBoxHeight }">
            <div class="seats-box">
                <div class="col" v-if="isUnllList.length">
                    <div
                        class="s-box"
                        :class="[{ 'first-row': item.head }, { 'has-row': item.duration }]"
                        v-for="(item, index) in isUnllList"
                        :key="index"
                    >
                        <span>{{ item.name }}</span>
                    </div>
                </div>
                <div class="box h5-box">
                    <div class="line" v-for="(item, index) in seatList" :key="index">
                        <Item
                            :data.sync="item"
                            :row="index"
                            :middleColumn="renderData.middleColumn"
                            v-if="sonRefresh"
                            @selectSeat="selectSeat"
                        ></Item>
                    </div>
                    <!-- 防止没有标准宽度参照物 -->
                    <div class="line">
                        <Item :data="[null]"></Item>
                    </div>
                </div>
            </div>
        </div>
        <div class="ft">
            <div class="movie-name">
                {{ renderData.movieName }}
                <div
                    class="more-session"
                    :class="{ down: openSessionStatus }"
                    @click="openSwitchSession"
                    v-if="sessionList.length"
                >
                    更换场次
                </div>
            </div>
            <div class="time-list">
                <div class="day">{{ renderData.showDateOfChinese }}</div>
                <div class="movie-information">
                    <div class="date">{{ renderData.showDay }}</div>
                    <div class="start-end-at">{{ renderData.startAt }}~{{ renderData.endAt }}</div>
                    <div class="show-type">{{ renderData.showVersionType }}</div>
                </div>
            </div>
            <div class="session-list" v-show="openSessionStatus">
                <div class="day">
                    <span
                        class="span"
                        v-for="(item, index) in renderData.showDateOfChinese"
                        :key="index"
                    >
                        {{ item }}
                    </span>
                </div>
                <div
                    class="session-item"
                    :class="{ current: item.id == id }"
                    v-for="(item, index) in sessionList"
                    :key="index"
                    @click="switchSession(item)"
                >
                    <div class="time">
                        <div class="start-at">{{ item.startAt }}</div>
                        <div class="end-at">{{ item.endAt }}</div>
                    </div>
                    <div class="show-type">{{ item.showType }}</div>
                    <div class="price">
                        <span>¥{{ item.price }}</span>
                        <span class="span">起</span>
                    </div>
                </div>
            </div>
            <div class="seats" v-if="selectList.length">
                <div class="cell" v-for="(item, index) in selectList" :key="index">
                    <div class="wrap">
                        <div class="left">
                            <div>
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="red">
                                <span>¥{{ item.price }}</span>
                            </div>
                        </div>
                        <div class="right" @click="closeSeatItem(item, index)">
                            <img class="img" :src="require('@/assets/icons/icon-close.png')" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="switch flex">
                <div class="switch-text">
                    自动调座
                    <span class="icon-info-tip" @click="openAdjustTip"></span>
                </div>
                <div
                    class="switch-box"
                    @click="switchAcceptAdjust"
                    :class="{ 'accept-adjust': acceptAdjust }"
                ></div>
            </div>
            <div class="text">所选座位已售时，系统自动调整至最佳观影座位</div>
            <div class="btns iphone-x-adaptation">
                <div class="btn" v-if="!selectList.length" @click="$toast('请先选座')">
                    <span>请先选座</span>
                </div>
                <div class="btn submit" @click="submit" v-else>
                    <span>¥{{ sumPrice }}确定选座</span>
                </div>
            </div>
        </div>
        <div class="dialog" v-if="showEmptyErrorTipStatus">
            <div class="dialog-box">
                <div class="icon-list" v-if="showEmptyErrorTipStatus == 1">
                    <div class="icon-item"></div>
                    <div class="icon-item no-select"></div>
                    <div class="icon-item"></div>
                </div>
                <div class="icon-list" v-if="showEmptyErrorTipStatus == 2">
                    <div class="icon-item no-select"></div>
                    <div class="icon-item"></div>
                    <div class="icon-item no-select"></div>
                </div>
                <div class="tip">{{ showEmptyErrorTipText }}</div>
            </div>
        </div>
        <div
            class="accept-adjust-dialog"
            v-if="acceptAdjustDialogStatus"
            @click="acceptAdjustDialogStatus = false"
        >
            <div class="content" @click.stop="">
                <div class="header"></div>
                <div class="message">
                    <p>为了节省您的购票时间，若您所选座位被占时</p>
                    <p style="color: rgba(217, 2, 9, 1)">
                        系统自动将座位调至剩余座位中最优临近座位
                    </p>
                </div>
                <div class="btn-list">
                    <div class="btn-item" @click="setAcceptAdjustStatus(false)">
                        <p>不调座</p>
                        <p>无座自动退款</p>
                    </div>
                    <div class="btn-item agree" @click="setAcceptAdjustStatus(true)">
                        <p>同意调座</p>
                        <p>最优临近座位</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import number from '@/lib/number';
import { MOVIE_SINGLE_QUOTA_NUMBER, MOVIE_SINGLE_QUOTA_NUMBER_OF_QMM } from '@/lib/constant';
import {
    GET_MOVIE_SCENE_INFO,
    GENERATE_TOKEN,
    CREATE_MOVIE_ORDER,
    GET_USER_HOLD_ORDER_SEAT_COUNT,
    GET_MOVIE_SCENE_LIST,
} from 'api';
import {
    PAGE_PAY,
    PAGE_TICKET_TYPE,
    PAGE_CINEMA_INFO,
    PAGE_ROOT,
    PAGE_MOVIE_SEAT_SELECTION,
} from 'page';
import Item from './components/item.vue';
import Thumbnail from './components/thumbnail.vue';

const acceptAdjustConfirmMsg =
    '为了节省您的购票时间，若您所选座位被占时，<span style="color:#ff2827;">系统自动将座位调至剩余座位中最优临近座位</span>';
const acceptAdjustConfirmConfirmText =
    '<p style="font-size: 14px;line-height: 20px;margin-top: 8px;margin-bottom: 8px;color:#409EFF;">同意调坐<br>最优临近座位</p>';
const acceptAdjustConfirmCancelText =
    '<p style="font-size: 14px;line-height: 20px;margin-top: 8px;margin-bottom: 8px;">不调座<br>无座自动退款</p>';

export default {
    data() {
        return {
            id: 0,
            renderData: {},
            acceptAdjust: null,
            seatList: [],
            selectList: [],
            isUnllList: [],
            sessionList: [],
            centerNum: 0,
            sonRefresh: true,
            thumbnailRefresh: true,
            seatNum: 4,
            showEmptyErrorTipStatus: 0,
            showEmptyErrorTipText: '',
            areaPrices: [],
            priceBoxHeight: '',
            acceptAdjustDialogStatus: false,
            isSubmit: false,
            openSessionStatus: false,
            date: '',
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$util.loading();
            vm.init();
        });
    },
    computed: {
        sumPrice() {
            let price = 0;
            if (this.renderData.enableAuctionMode) {
                let minPrice = 0;
                let maxPrice = 0;
                for (let i = 0; i < this.selectList.length; i++) {
                    let item = this.selectList[i];
                    let tempMinPrice =
                        Math.round(number.operation(`${item.fastDrawModePrice}*${0.2}`) * 10) / 10;
                    let tempMaxPrice =
                        Math.round(number.operation(`${item.fastDrawModePrice}*${0.8}`) * 10) / 10;
                    minPrice = number.operation(`${minPrice}+${tempMinPrice}`);
                    maxPrice = number.operation(`${maxPrice}+${tempMaxPrice}`);
                }
                return `${+minPrice}~${+maxPrice}`;
            } else {
                for (let i = 0; i < this.selectList.length; i++) {
                    let item = this.selectList[i];
                    price = number.operation(`${price}+${item.price}`);
                }
            }
            return price;
        },
    },
    components: {
        Item,
        Thumbnail,
    },
    created() {
        this.renderData.cinemaName = this.$route.query.cinemaName || '';
        this.renderData.movieName = this.$route.query.titleName || '';
        if (!this.$route.query.hasOwnProperty('date')) {
            this.date = 0;
        } else {
            this.date = this.$route.query.date;
        }
    },
    methods: {
        // 初始化方法
        init() {
            this.$store.dispatch('getExposeMethod').then(exposeRes => {
                if (exposeRes.hasOwnProperty('defaultAcceptAdjust')) {
                    this.acceptAdjust = exposeRes.defaultAcceptAdjust;
                } else {
                    this.acceptAdjust = false;
                }
            });
            this.seatList = [];
            this.selectList = [];
            this.isUnllList = [];
            this.centerNum = 0;
            this.sonRefresh = true;
            this.thumbnailRefresh = true;
            this.id = this.$route.query.sceneId;
            if (
                this.$store.state.common.config &&
                this.$store.state.common.config.enableFastDrawMode
            ) {
                this.seatNum = MOVIE_SINGLE_QUOTA_NUMBER_OF_QMM;
            } else {
                this.seatNum = MOVIE_SINGLE_QUOTA_NUMBER;
            }
            this.getData();
            this.getUserOrderCount();
        },
        // 获取持有订单数量
        getUserOrderCount() {
            this.$util
                .post(GET_USER_HOLD_ORDER_SEAT_COUNT, {
                    showId: this.id,
                })
                .then(res => {
                    if (res.success) {
                        if (res.data.orderCount > 0) {
                            this.$confirm.open({
                                title: '温馨提示',
                                message: `您已经购买了该场次${res.data.orderCount}个订单，共${res.data.seatCount}个座位。`,
                                confirmText: '朕知道了',
                                hideCancelBtn: true,
                            });
                        }
                    }
                });
        },
        // 获取座位信息
        getData() {
            this.renderData.areaPrices = [];
            this.$util
                .post(GET_MOVIE_SCENE_INFO, {
                    showId: this.id,
                })
                .then(res => {
                    this.$util.unloading();
                    if (res.success) {
                        if (!res.data.id) {
                            this.$toast('获取场次信息失败，请选择其他场次');
                            return;
                        }

                        res.data.showDay = moment(res.data.showTime).format('M月D日');
                        res.data.startAt = moment(res.data.showTime).format('HH:mm');
                        res.data.endAt = moment(res.data.showEndTime).format('HH:mm');

                        if (this.$store.getters.platformConfig.platform.useMovieOriginPrice) {
                            for (let i = 0; i < res.data.seats.length; i++) {
                                const line = res.data.seats[i];
                                for (let j = 0; j < line.length; j++) {
                                    const item = line[j];
                                    if (item) {
                                        item._price = item.price;
                                        item.price = item.fastDrawModePrice;
                                    }
                                }
                            }
                            if (res.data.areaPrices) {
                                for (let i = 0; i < res.data.areaPrices.length; i++) {
                                    const item = res.data.areaPrices[i];
                                    if (item) {
                                        item._price = item.price;
                                        item.price = item.qmmPrice;
                                    }
                                }
                            }
                        }

                        if (!res.data.enableCompetitionMode) {
                            for (let i = 0; i < res.data.seats.length; i++) {
                                const line = res.data.seats[i];
                                for (let j = 0; j < line.length; j++) {
                                    const item = line[j];
                                    if (item) {
                                        item._price = item.price;
                                        item.price = item.fastDrawModePrice;
                                    }
                                }
                            }

                            if (res.data.areaPrices) {
                                for (let i = 0; i < res.data.areaPrices.length; i++) {
                                    const item = res.data.areaPrices[i];
                                    if (item) {
                                        item._price = item.price;
                                        item.price = item.qmmPrice;
                                    }
                                }
                            }
                        }

                        this.renderData = res.data;
                        this.$nextTick(() => {
                            this.priceBoxHeight = this.$refs.priceBox.clientHeight + 'px';
                        });

                        this.seatList = res.data.seats;
                        this.isUnllList = res.data.shadows;
                        this.$nextTick(() => {
                            this.seatBoxMove();
                        });
                        this.getSessionList();
                    } else {
                        this.$toast(res.message);
                    }
                });
        },
        getSessionList() {
            this.$util
                .post(GET_MOVIE_SCENE_LIST, {
                    cinemaId: this.renderData.cinemaId,
                    movieId: this.renderData.filmId,
                    date: this.date,
                    pageIndex: 1,
                    pageSize: 50,
                })
                .then(res => {
                    if (res.success) {
                        this.sessionList = res.data.filter(v => v.status == 0);
                    }
                });
        },
        // 切换是否自动选座
        switchAcceptAdjust() {
            if (this.acceptAdjust) {
                // this.$confirm.open({
                //     title: '',
                //     message: acceptAdjustConfirmMsg,
                //     confirmText: acceptAdjustConfirmConfirmText,
                //     cancelText: acceptAdjustConfirmCancelText,
                //     error: (res) => {
                //         this.acceptAdjust = !this.acceptAdjust;
                //     }
                // })
                this.acceptAdjustDialogStatus = true;
                this.isSubmit = false;
            } else {
                this.acceptAdjust = !this.acceptAdjust;
            }
        },
        // 选座区域移动
        seatBoxMove() {
            const centerNum = this.renderData.middleColumnIndex;
            const h5CinemaBox = document.getElementsByClassName('h5-cinema-box')[0];
            const h5SeatsBox = document.getElementsByClassName('h5-box')[0];
            const colBox = document.getElementsByClassName('col')[0];
            if (h5CinemaBox) {
                let pageWidth = document.body.offsetWidth;
                let itemWidth = document.getElementsByClassName('none-bg')[0].offsetWidth;
                h5SeatsBox.style.left =
                    pageWidth / 2 -
                    (itemWidth + (itemWidth / 50) * 4) -
                    (itemWidth / 50) * 58 * (centerNum - 1) +
                    'px';
                var pageX,
                    pageY,
                    initX,
                    initY,
                    scale = 1,
                    isTouch = false;
                var start = [];
                h5CinemaBox.addEventListener(
                    'touchstart',
                    function (e) {
                        //手指按下时的手指所在的X，Y坐标
                        pageX = e.targetTouches[0].pageX;
                        pageY = e.targetTouches[0].pageY;
                        //初始位置的X，Y 坐标
                        initX = h5SeatsBox.offsetLeft;
                        initY = h5SeatsBox.offsetTop;
                        //记录初始 一组数据 作为缩放使用
                        if (e.touches.length >= 2) {
                            //判断是否有两个点在屏幕上
                            start = e.touches; //得到第一组两个点
                        }
                        //表示手指已按下
                        isTouch = true;
                    },
                    false
                );
                h5CinemaBox.addEventListener(
                    'touchmove',
                    function (e) {
                        e.preventDefault();
                        if (e.touches.length == 1 && isTouch) {
                            var touchMoveX = e.targetTouches[0].pageX,
                                touchMoveY = e.targetTouches[0].pageY;
                            h5SeatsBox.style.left =
                                parseInt(touchMoveX) - parseInt(pageX) + parseInt(initX) + 'px';
                            h5SeatsBox.style.top =
                                parseInt(touchMoveY) - parseInt(pageY) + parseInt(initY) + 'px';
                            colBox.style.top = h5SeatsBox.style.top;
                        }
                        if (e.touches.length >= 2 && isTouch) {
                            var now = e.touches;
                            scale =
                                scale *
                                (getDistance(now[0], now[1]) / getDistance(start[0], start[1]));
                            scale = scale.toFixed(2) < 1.8 ? scale.toFixed(2) : 1.8;
                            scale = scale > 0.8 ? scale : 0.8;
                            h5SeatsBox.style.transition = 'all 0.4s';
                            colBox.style.transition = 'all 0.4s';
                            h5SeatsBox.style.transform = 'scale(' + scale + ')';
                            colBox.style.transform = 'scale(' + scale + ')';
                        } else {
                            h5SeatsBox.style.transition = 'none';
                            colBox.style.transition = 'none';
                        }
                    },
                    false
                );
                h5CinemaBox.addEventListener(
                    'touchend',
                    function (e) {
                        if (isTouch) {
                            isTouch = false;
                        }
                    },
                    false
                );
                function getDistance(p1, p2) {
                    var x = p2.pageX - p1.pageX,
                        y = p2.pageY - p1.pageY;
                    return Math.sqrt(x * x + y * y);
                }
            }
        },
        // 选座
        selectSeat(item, row, column) {
            if (!item) {
                return;
            }
            if (item.status == 'LK') {
                this.$toast('该座位已售出');
                return;
            }
            this.seatList[row][column].select = !this.seatList[row][column].select;
            let tempItem = this.seatList[row][column];
            if (tempItem.select) {
                if (this.selectList.length + (tempItem.love ? 1 : 0) + 1 > this.seatNum) {
                    this.seatList[row][column].select = !tempItem.select;
                    this.$toast(`最多只能选择${this.seatNum}个座位`);
                    return;
                }
                if (tempItem.love == 1) {
                    this.seatList[row][column + 1].select = tempItem.select;
                    this.selectList.push(tempItem);
                    this.selectList.push(this.seatList[row][column + 1]);
                } else if (tempItem.love == 2) {
                    this.seatList[row][column - 1].select = tempItem.select;
                    this.selectList.push(this.seatList[row][column - 1]);
                    this.selectList.push(tempItem);
                } else {
                    this.selectList.push(tempItem);
                }
                this.thumbnailRefresh = false;
                this.$nextTick(() => {
                    this.thumbnailRefresh = true;
                });
            } else {
                this.removeSelectSeat(item);
            }
        },
        // 取消选座
        closeSeatItem(item, index) {
            this.removeSelectSeat(item);
        },
        // 移除选座
        removeSelectSeat(item) {
            for (let i = 0; i < this.selectList.length; i++) {
                const _item = this.selectList[i];
                if (_item && _item.id == item.id) {
                    this.selectList[i].select = false;
                    this.selectList.splice(i, 1);
                    if (item.love == 1) {
                        this.selectList[i].select = false;
                        this.selectList.splice(i, 1);
                    } else if (item.love == 2) {
                        this.selectList[i - 1].select = false;
                        this.selectList.splice(i - 1, 1);
                    }
                    break;
                }
            }
            this.sonRefresh = false;
            this.thumbnailRefresh = false;
            this.$nextTick(() => {
                this.sonRefresh = true;
                this.thumbnailRefresh = true;
            });
        },
        // 验证留空
        checkBlank() {
            let resultStatus = true;
            for (let i = 0; i < this.seatList.length; i++) {
                const lineItem = this.seatList[i];
                let lineText =
                    '3' +
                    lineItem
                        .map(function (item, index) {
                            if (!item) return 3;
                            else if (item.status == 'LK') return 2;
                            else if (item.select) return 1;
                            else return 0;
                        })
                        .join('') +
                    '3';
                if (lineText.indexOf('101') > -1) {
                    this.showEmptyErrorTipText = '座位中间不能留空哟～';
                    this.showEmptyErrorTipStatus = 1;
                    resultStatus = false;
                } else if (lineText.indexOf('010') > -1 && lineText.indexOf('00100') == -1) {
                    this.showEmptyErrorTipText = '座位旁边不能留空哟～';
                    this.showEmptyErrorTipStatus = 2;
                    resultStatus = false;
                } else if (lineText.indexOf('0110') > -1 && lineText.indexOf('001100') == -1) {
                    this.showEmptyErrorTipText = '座位旁边不能留空哟～';
                    this.showEmptyErrorTipStatus = 2;
                    resultStatus = false;
                } else if (lineText.indexOf('01110') > -1 && lineText.indexOf('0011100') == -1) {
                    this.showEmptyErrorTipText = '座位旁边不能留空哟～';
                    this.showEmptyErrorTipStatus = 2;
                    resultStatus = false;
                } else if (lineText.indexOf('011110') > -1 && lineText.indexOf('00111100') == -1) {
                    this.showEmptyErrorTipText = '座位旁边不能留空哟～';
                    this.showEmptyErrorTipStatus = 2;
                    resultStatus = false;
                }
                if (!resultStatus) {
                    setTimeout(() => {
                        this.showEmptyErrorTipStatus = 0;
                    }, 3000);
                    break;
                }
            }
            return resultStatus;
        },
        // 提交
        submit() {
            this.$util.debounce(this.submitNext)();
        },
        submitNext() {
            // 验证是否有留空
            if (!this.checkBlank()) {
                return;
            }
            if (this.acceptAdjust) {
                // this.getToken();
                this.createOrder();
            } else {
                this.acceptAdjustDialogStatus = true;
                this.isSubmit = true;
                // this.$confirm.open({
                //     title: '',
                //     message: acceptAdjustConfirmMsg,
                //     confirmText: acceptAdjustConfirmConfirmText,
                //     cancelText: acceptAdjustConfirmCancelText,
                //     isShieldClose: false,
                //     success: () => {
                //         this.acceptAdjust = true;
                //         this.getToken();
                //     },
                //     error: (res) => {
                //         if (res.cource == 'btn') {
                //             this.getToken();
                //         }
                //     }
                // })
            }
        },
        // 获取 token
        getToken() {
            this.$util.get(GENERATE_TOKEN).then(res => {
                if (res.success) {
                    this.$util.throttle(this.createOrder)();
                }
            });
        },
        // 创建订单
        createOrder(token) {
            const { id, selectList, acceptAdjust } = this;
            let drawMode = 0;
            if (
                this.renderData.enableFastDrawMode &&
                this.renderData.enableFastDrawMode +
                    this.renderData.enableAuctionMode +
                    this.renderData.enableCompetitionMode ==
                    1
            ) {
                drawMode = 5;
            }
            this.$util
                .post(CREATE_MOVIE_ORDER, {
                    showId: id,
                    seats: selectList,
                    seatsCount: selectList.length,
                    token,
                    acceptAdjust,
                    platformId: this.$store.state.common.platformId,
                    // drawMode: this.$store.state.common.config.enableFastDrawMode ? 5 : 0,
                    drawMode: drawMode,
                })
                .then(res => {
                    if (res.success) {
                        this.$util.pageJump(PAGE_PAY, {
                            orderNo: res.data.orderNo,
                            // 特惠出票模式是否开启
                            ecm: this.renderData.enableCompetitionMode,
                            // 直接购票模式是否开启
                            efdm: this.renderData.enableFastDrawMode,
                            // 询价比价购票模式是否开启
                            eam: this.renderData.enableAuctionMode,
                        });
                        // if (!this.$store.state.common.config.enableFastDrawMode) {
                        //     this.$util.pageJump(PAGE_PAY, {
                        //         // orderId: res.data.id,
                        //         orderNo: res.data.orderNo,
                        //     });
                        // } else {
                        //     this.$util.pageJump(PAGE_TICKET_TYPE, {
                        //         // orderId: res.data.id,
                        //         orderNo: res.data.orderNo,
                        //         // 特惠出票模式是否开启
                        //         ecm: this.renderData.enableCompetitionMode,
                        //         // 直接购票模式是否开启
                        //         efdm: this.renderData.enableFastDrawMode,
                        //         // 特惠出票的原因   1:开场时间    2:限流
                        //         dcmt: this.renderData.disableCompetitionModeType,
                        //         // 限流分钟数
                        //         cmri: this.renderData.competitionModeReleaseInterval,
                        //     });
                        // }
                    }
                });
        },
        // 设置调座状态
        setAcceptAdjustStatus(status) {
            this.acceptAdjust = status;
            if (this.isSubmit) {
                this.getToken();
            }
            this.acceptAdjustDialogStatus = false;
        },
        // 打开更多场次
        openSwitchSession() {
            this.openSessionStatus = !this.openSessionStatus;
        },
        // 切换到当前其他场次
        switchSession(item) {
            this.$util.pageJump({
                path: PAGE_MOVIE_SEAT_SELECTION,
                query: {
                    date: this.date,
                    sceneId: item.id,
                },
                config: {
                    jumpType: 1,
                },
            });
            // this.$store.commit('reloadApp');
            this.$util.loading();
            this.init();
        },
        openAdjustTip() {
            this.$confirm.open({
                title: '调座规则',
                message:
                    '由于出票过程中存在时间差，可能存在已选座位被占情况，出票成功率将降低。为了不耽误您的时间，选择自动调座后我们将在所选位置无法下单时选择临近最优位，如多张将继续为您保持连座。',
                confirmText: '我知道了',
                hideCancelBtn: true,
            });
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
.cinema-seat-page {
    // min-height: calc(100vh - .pxToRem(280) []);
    height: 100vh;
    box-sizing: border-box;
    position: relative;

    .price-box {
        .line {
            display: flex;
            height: .pxToRem(36) [];
            padding-top: .pxToRem(20) [];
            .item {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                .img {
                    width: .pxToRem(32) [];
                    height: .pxToRem(30) [];
                    margin-top: .pxToRem(-2) [];
                }
                .value {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.9);
                    margin-left: .pxToRem(10) [];
                }
            }
        }

        .selection-name {
            margin: 0 auto;
            margin-top: .pxToRem(34) [];
            padding-bottom: .pxToRem(16) [];
            text-align: center;
            .span {
                width: .pxToRem(364) [];
                margin: 0 auto;
            }
            &:after {
                content: ' ';
                .base-center-x;
                top: .pxToRem(-20) [];
                width: .pxToRem(576) [];
                height: .pxToRem(36) [];
                background: url('~@/assets/icons/icon-selection-hall-bg.png');
                background-size: cover;
            }
        }
        .thumbnail {
            position: absolute;
            bottom: .pxToRem(-10) [];
            left: 0;
            transform: translateY(100%);
            z-index: 101;
        }
    }

    .h5-cinema-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        overflow: hidden;
        .t {
            height: .pxToRem(90) [];
            text-align: center;
            font-size: .pxToRem(26) [];
            line-height: .pxToRem(60) [];
            overflow: hidden;
            position: relative;
            z-index: 1;

            &::before {
                position: absolute;
                bottom: .pxToRem(16) [];
                width: .pxToRem(400) [];
                height: .pxToRem(200) [];
                background-color: #e6e7e9;
                border-radius: 50%;
                text-align: center;
                line-height: .pxToRem(200) [];
                left: 50%;
                margin-left: .pxToRem(-200) [];
                content: '';
            }

            .txt {
                z-index: 2;
                position: relative;
                color: #666;
            }
        }

        .seats-box {
            position: absolute;
            top: 0;
            left: 0;

            .col {
                position: absolute;
                left: .pxToRem(10) [];
                top: .pxToRem(80) [];
                width: .pxToRem(30) [];
                z-index: 9;
                // background: rgba(0, 0, 0, 0.2);
                text-align: center;

                .s-box {
                    font-size: .pxToRem(24) [];
                    color: #fff;
                    height: .pxToRem(56) [];
                    line-height: .pxToRem(56) [];
                    position: relative;

                    &.has-row {
                        background: rgba(0, 0, 0, 0.2);
                    }
                    &.excessive {
                        background: rgba(0, 0, 0, 0.2);
                    }

                    &.first-row {
                        &:after {
                            content: ' ';
                            position: absolute;
                            top: .pxToRem(-20) [];
                            left: 0;
                            height: .pxToRem(20) [];
                            width: .pxToRem(30) [];
                            border-radius: .pxToRem(15) [] .pxToRem(15) [] 0 0;
                            background: rgba(0, 0, 0, 0.2);
                            z-index: -1;
                        }
                    }
                }

                &:before {
                    content: ' ';
                    position: absolute;
                    bottom: .pxToRem(-20) [];
                    left: 0;
                    height: .pxToRem(20) [];
                    width: .pxToRem(30) [];
                    border-radius: 0 0 .pxToRem(15) [] .pxToRem(15) [];
                    background: rgba(0, 0, 0, 0.2);
                    z-index: -1;
                }
            }
        }
    }

    .box {
        position: absolute;
        top: .pxToRem(80) [];
        left: 0;

        .line {
            width: .pxToRem(1000) [];
        }
    }
}

.ft {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: .pxToRem(30) [] 0 .pxToRem(10) [];
    background: #fff;
    z-index: 100;
    box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] .pxToRem(0) [] rgba(0, 0, 0, 0.08);
    border-radius: .pxToRem(40) [] .pxToRem(40) [] 0 0;

    .movie-name {
        padding: 0 .pxToRem(40) [];
        line-height: .pxToRem(48) [];
        font-size: .pxToRem(32) [];
        color: rgba(0, 0, 0, 0.9);
        font-weight: 600;
        .more-session {
            position: absolute;
            right: .pxToRem(40) [];
            top: 0;
            padding-right: .pxToRem(40) [];
            line-height: .pxToRem(36) [];
            font-size: .pxToRem(24) [];
            font-weight: 600;
            color: rgba(0, 0, 0, 0.9);
            &::after {
                content: ' ';
                position: absolute;
                right: 0;
                top: 0;
                width: .pxToRem(32) [];
                height: .pxToRem(32) [];
                background-image: url('~@/assets/icons/icon-down.png');
                background-size: contain;
                transition: all 0.3s;
            }
            &:not(.down) {
                &::after {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .time-list {
        display: flex;
        padding: 0 .pxToRem(40) [];
        margin-top: .pxToRem(8) [];
        font-size: .pxToRem(24) [];
        line-height: .pxToRem(38) [];
        color: rgba(0, 0, 0, 0.5);
        align-items: center;
        .day {
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);
            margin-right: .pxToRem(10) [];
        }
        .movie-information {
            display: flex;
            line-height: .pxToRem(38) [];
            font-size: .pxToRem(24) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.5);
            .date {
                margin-right: .pxToRem(10) [];
            }
            .start-end-at {
                margin-right: .pxToRem(24) [];
            }
        }
    }
    .session-list {
        display: flex;
        height: .pxToRem(154) [];
        padding: 0 .pxToRem(40) [];
        margin-top: .pxToRem(24) [];
        white-space: nowrap;
        overflow-x: auto;
        .day {
            display: flex;
            width: .pxToRem(32) [];
            height: .pxToRem(154) [];
            background: @theme_color_first;
            border: unset;
            border-radius: .pxToRem(16) [];
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-right: .pxToRem(8) [];
            .span {
                width: .pxToRem(32) [];
                text-align: center;
                line-height: .pxToRem(28) [];
            }
        }
        .session-item {
            display: inline-block;
            height: .pxToRem(154) [];
            background: #f5f5f5;
            border-radius: .pxToRem(16) [];
            border: .pxToRem(1) [] solid #f5f5f5;
            box-sizing: border-box;
            margin-right: .pxToRem(8) [];
            .time {
                display: flex;
                margin: .pxToRem(16) [] .pxToRem(16) [] 0;
                .start-at,
                .end-at {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(35) [];
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.9);
                }
                .start-at {
                    padding-right: .pxToRem(40) [];
                    &::after {
                        content: ' ';
                        position: absolute;
                        top: .pxToRem(4) [];
                        right: .pxToRem(4) [];
                        background-image: url('~@/assets/icons/icon-move-right.png');
                        background-size: contain;
                        width: .pxToRem(32) [];
                        height: .pxToRem(32) [];
                    }
                }
            }
            .show-type {
                padding: 0 .pxToRem(16) [];
                text-align: left;
                line-height: .pxToRem(36) [];
                font-size: .pxToRem(24) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                margin-top: .pxToRem(4) [];
            }
            .price {
                padding: 0 .pxToRem(16) [];
                line-height: .pxToRem(46) [];
                font-size: .pxToRem(24) [];
                font-weight: 600;
                color: #d90209;
                text-align: left;
                .span {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.5);
                    margin-left: .pxToRem(4) [];
                }
            }
            &.current {
                background: #ffdbb6;
                border: .pxToRem(1) [] solid #ffdbb6;
            }
        }
    }
    .switch {
        padding: .pxToRem(20) [] .pxToRem(40) [] 0;
        margin-top: .pxToRem(24) [];
        height: .pxToRem(48) [];
        justify-content: space-between;
        align-items: center;

        &-text {
            height: .pxToRem(40) [];
            line-height: .pxToRem(40) [];
            font-size: .pxToRem(30) [];
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);
        }

        &-box {
            width: .pxToRem(80) [];
            height: .pxToRem(48) [];
            background: #f0f0f0;
            border-radius: .pxToRem(24) [];
            &::after {
                content: ' ';
                .base-center-y;
                right: .pxToRem(34) [];
                .sq(43);
                background: white;
                border-radius: 100%;
                transition: all 0.3s;
            }
            &.accept-adjust {
                background: @theme_color_first;
                &::after {
                    right: .pxToRem(3) [];
                }
            }
        }
        .icon-info-tip {
            .sq(40);
            background: red;
            margin-left: .pxToRem(32) [];
            &::before {
                content: ' ';
                .base-center;
                .sq(32);
                background: url('~@/assets/icons/icon-info-tip.png');
                background-size: contain;
            }
        }
        &::before {
            content: ' ';
            position: absolute;
            top: 0;
            left: .pxToRem(40) [];
            right: .pxToRem(40) [];
            height: .pxToRem(1) [];
            background: rgba(0, 0, 0, 0.15);
        }
    }

    .text {
        padding: 0 .pxToRem(40) [];
        margin-top: .pxToRem(10) [];
        font-size: .pxToRem(24) [];
        color: #d90209;
        line-height: .pxToRem(38) [];
    }

    .seats {
        padding: 0 .pxToRem(40) [];
        height: .pxToRem(80) [];
        box-sizing: border-box;
        white-space: nowrap;
        display: -webkit-box;
        overflow-x: scroll;
        margin-top: .pxToRem(16) [];
        .cell {
            margin-right: .pxToRem(10) [];
            .wrap {
                display: flex;
                font-size: .pxToRem(24) [];
                background: #f5f5f5;
                border-radius: .pxToRem(4) [];
                height: .pxToRem(80) [];
                box-sizing: border-box;
                border-radius: .pxToRem(8) [];

                .left {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    padding-left: .pxToRem(20) [];
                    padding-right: .pxToRem(20) [];
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.9);
                    font-size: .pxToRem(24) [];
                    .red {
                        color: #d80108;
                        font-weight: bold;
                    }
                }

                .right {
                    text-align: center;
                    .img {
                        .sq(24);
                        padding: .pxToRem(16) [] .pxToRem(10) [];
                    }
                }
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }

    .btns {
        padding-left: .pxToRem(40) [];
        padding-right: .pxToRem(40) [];
        margin-top: .pxToRem(50) [];
        .btn {
            height: .pxToRem(80) [];
            text-align: center;
            font-size: .pxToRem(28) [];
            line-height: .pxToRem(80) [];
            background: @theme_color_first;
            color: rgba(0, 0, 0, 0.3);
            border-radius: .pxToRem(40) [];
            border: none;
            &.submit {
                color: rgba(0, 0, 0, 0.9);
            }
        }
    }
}

.dialog {
    .dialog-box {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.75);
        padding: .pxToRem(20) [];
        border-radius: .pxToRem(12) [];
        z-index: 100;
        @iconItemWidth: 48;
        @iconItemMR: 20;
        .icon-list {
            margin: 0 auto;
            width: .pxToRem(@iconItemWidth*3+ @iconItemMR*2) [];
            .icon-item {
                display: inline-block;
                width: .pxToRem(@iconItemWidth) [];
                height: .pxToRem(@iconItemWidth) [];
                margin-right: .pxToRem(@iconItemMR) [];
                background: url(~@/assets/icons/my-select-default.png);
                background-size: cover;
                &.no-select {
                    background: url(~@/assets/icons/default-0-default.png);
                    background-size: cover;
                    animation: myfirst 0.7s 3 linear;
                }
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .tip {
            color: white;
            font-size: .pxToRem(24) [];
        }
    }
}

.accept-adjust-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 101;
    .content {
        .base-center;
        width: .pxToRem(650) [];
        height: .pxToRem(566) [];
        background: #ffffff;
        border-radius: .pxToRem(40) [];
        .header {
            background: url('~@/assets/icons/icon-dialog-title-bg.png');
            background-size: contain;
            width: .pxToRem(650) [];
            height: .pxToRem(135) [];
            &::before {
                content: ' ';
                position: absolute;
                bottom: .pxToRem(-33) [];
                left: .pxToRem(206) [];
                width: .pxToRem(206) [];
                height: .pxToRem(136) [];
                background: url('~@/assets/icons/icon-dialog-title-logo.png');
                background-size: contain;
            }
        }
        .message {
            margin-top: .pxToRem(100) [];
            p {
                text-align: center;
                padding: 0 .pxToRem(40) [];
                line-height: .pxToRem(56) [];
                font-size: .pxToRem(28) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
            }
        }
        .btn-list {
            display: flex;
            justify-content: space-between;
            margin-top: .pxToRem(56) [];
            padding: 0 .pxToRem(50) [];
            .btn-item {
                width: .pxToRem(260) [];
                height: .pxToRem(104) [];
                background: #ffffff;
                border-radius: .pxToRem(52) [];
                border: 1px solid #313131;
                display: flex;
                flex-direction: column;
                justify-content: center;
                p {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(28) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.9);
                    text-align: center;
                }
                &.agree {
                    background: @theme_color_first;
                    border: 1px solid @theme_color_first;
                }
            }
        }
    }
}
@keyframes myfirst {
    0% {
        opacity: 1;
    }
    10% {
        opacity: 1;
    }
    40% {
        opacity: 0;
    }
    60% {
        opacity: 0;
    }
    90% {
        opacity: 1;
    }
    100% {
        opacity: 1;
    }
}
</style>
